import 'amfe-flexible'


import Vue from 'vue'

import App from './App'
import router from './router'
import store from './store'
import vc from 'vue-cookie'

import local from '@/libs/localStorage'

import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'

Vue.use(LoadingPlugin)
Vue.use(DatetimePlugin)

import "./plugins/cube-ui"


import "@/assets/css/base.css"

import "@/assets/icon/iconfont.css"


import vheader from "@/components/header"
Vue.component('vheader',vheader);




















(function () {
if(!!local.get("sapiInfo") && local.get("sapiInfo") != 'undefined'){
store.commit('setToken',{data:local.get("sapiInfo")});
}
})();


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
template: '<App/>',
components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js